import { render, staticRenderFns } from "./NormPage.vue?vue&type=template&id=4ed47a64"
import script from "./norm_page.js?vue&type=script&lang=js&external"
export * from "./norm_page.js?vue&type=script&lang=js&external"
import style0 from "./NormPage.vue?vue&type=style&index=0&id=4ed47a64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports